export const CRITICAL = 'CRITICAL_ERROR'
export const DATA_CONSUME = 'DATA_CONSUME'
export const DEMO_FINISHED = 'DEMO_FINISHED_ERROR'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const PORTRAIT_ERROR = 'PORTRAIT_ERROR'
export const UNSUPPORTED_DEVICE_ERROR = 'UNSUPPORTED_DEVICE_ERROR'
